var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsible-lending"},[_c('ResponsibleLending')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }